import * as globalOnScan from 'onscan.js/onscan';

class Scan {

  constructor() {
    this.init();
  }

  init() {
    const $this = this;
    try {
      globalOnScan.detachFrom(document);
    } catch(e) {
      console.log(e)
    }
    globalOnScan.attachTo(document, {
      minLength: 3,
      ignoreIfFocusOn: ['input', 'textarea'],
      onScan: function(value, iQty) {
        $this.sendEvent(value);
      },
      keyCodeMapper: function(oEvent) {
        if (oEvent.which == 189) {
          return '-';
        }
        if (oEvent.code == 'Period') {
          return '.';
        }
        if (oEvent.code == 'Semicolon') {
          return ':';
        }
        return globalOnScan.decodeKeyEvent(oEvent);
      },
      onScanError: function(oDebug){
        // Uncomment to develp/see errors
        //console.log(oDebug)
      }
    });
  }

  sendEvent(value) {
    const event = new Event('scanning');
    event.value = value;
    window.dispatchEvent(event);
  }
}

window.scan = new Scan();

export default window.scan;
